import React, { Component } from "react"
import NewsForm from './components/news-form'
import { newsService } from '../../services/tibesa.api'
import Swal from 'sweetalert2'

export default class NewsAdd extends Component {

    submitChanges(formData) {
        Swal.fire({
            title: '¿Seguro que deseas guardar la Noticia?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí',
            cancelButtonText: 'Cancelar',
            showLoaderOnConfirm: true,
            preConfirm: () => {
                return newsService.create(formData)
                    .then(response => {
                        return response;
                    })
                    .catch(error => {
                        Swal.showValidationMessage(
                            `Error en la petición: ${error}`
                        )
                    });
            },
            allowOutsideClick: () => !Swal.isLoading()
        })
            .then((response) => {
                console.log(response);
                if (response.value && response.value.data && response.value.data.status == 200) {
                    Swal.fire(
                        '¡Perfecto!',
                        '¡Nueva Noticia creada!',
                        'success'
                    ).then(() => {
                        if (response.value.data.results) {
                            window.location.href = `/news/${response.value.data.results}`;
                        }
                        else {
                            window.location.href = '/news';
                        }
                    });
                } else if(!response.dismiss == 'cancel') {
                    Swal.fire(
                        'Algo salio mal :C',
                        'Hubo un error al realizar la petición',
                        'error'
                      );
                }
            });
    }


    render() {
        return (
            <>
                <div className="air__utils__heading">
                    <a href="/news">Listado de Noticias</a><span>{" "}/{" "}Agregar Noticia</span>
                </div>
                <NewsForm onSubmit={this.submitChanges}></NewsForm>
            </>
        )
    }
}
